<template>
<Fragment>
    <ExpandableDataTableRow 
        :item="item" :label="label" 
        :level="level"
        :canWrite="canWrite"
        :visible="visible"

        @select-item="$emit('select-item', $event)"
        @clone="$emit('clone', $event)"
        @delete="$emit('delete', $event)"
        @edit="$emit('edit', $event)"
        @statistics="$emit('statistics', $event)"
    >
    </ExpandableDataTableRow>
</Fragment>
</template>

<script>

import {Fragment} from 'vue-fragment';

export default {
    name: 'ExpandableDataTableChild',
    status: 'prototype',
    release: '0.0.1',
    components: {
        Fragment,
        ExpandableDataTableRow: () =>  import('./ExpandableDataTableRow.vue'),
    },
    props: {
        item: {
            type: Object,
            required: true
        },
        label: {
            type: String,
            required: true
        },
        level: {
            type: Number,
            default: 0
        },
        visible: {
            type: Boolean,
            default: false
        },
        canWrite: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style lang="scss" scoped>

</style>